import { h, Component } from 'preact';
import { Icon } from '@cube/blocks';
import { trackProps, DIMENSION } from '@cube/track';
import ariaIDProvider, { ScreenReaderText } from '../a11y';
import { A11Y_ICON_LABEL_MAP } from './constants';

export class IconListItem extends Component {
	handleClickLocation = () => {
		this.props.onClickLocation && this.props.onClickLocation(this.props.location);
	};

	handleClickIcon = () => {
		this.props.onClickIcon && this.props.onClickIcon(this.props.location);
	};

	render({ onClickIcon, icon, location, a11yId, ...props }) {
		const btnDisabled = !onClickIcon;
		return (
			<li {...props}>
				<a id={a11yId}
					onClick={this.handleClickLocation}
					href="javascript:"
					{...trackProps({
						[DIMENSION.componentpath]: 'Change',
						[DIMENSION.text]: location.name
					}, this.context)}
				>
					{location.name}
				</a>
				<button
					tabindex={btnDisabled && -1}
					onClick={this.handleClickIcon}
				>
					<Icon aria-labelledby={a11yId} name={icon} />
					<ScreenReaderText>{A11Y_ICON_LABEL_MAP[icon]}</ScreenReaderText>
				</button>
			</li>
		);
	}
}

export default ariaIDProvider('icon-list-item')(IconListItem);
